module.exports = __webpack_public_path__ + "img/FPG.b0c46c12.jpg";